// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';
import meta from './data/meta.json';
import Zion from './utils/Zion';
// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}


// if (window.innerWidth < 779) {
//   d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

//   d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'block');
//   d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
// } else if (window.innerWidth < 4000) {
//   d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'block');
//   d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

//   d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
//   d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
// }

d3.selectAll('button#stlouis').on('click', (d) => {
  if (window.innerWidth < 779) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'block');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
  } else if (window.innerWidth < 4000) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'block');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
  }
});

d3.selectAll('button#nola').on('click', (d) => {
  if (window.innerWidth < 779) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'block');
  } else if (window.innerWidth < 4000) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'block');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
  }
});

d3.selectAll('button#baltimore').on('click', (d) => {
  if (window.innerWidth < 779) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'block');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
  } else if (window.innerWidth < 4000) {
    d3.selectAll('#g-ai2html-graphic-desktop').style('display', 'block');
    d3.selectAll('#g-ai2html-graphic-desktop-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-desktop-nola').style('display', 'none');

    d3.selectAll('#g-ai2html-graphic-mobile375').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-stlouis').style('display', 'none');
    d3.selectAll('#g-ai2html-graphic-mobile375-nola').style('display', 'none');
  }
});
